import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import FloatingPlayerIndicator from './FloatingPlayerIndicator';
import AchievementToast from './AchievementToast';

function SportGrid({
  title,
  subtitle,
  items,
  showBackButton = false,
  backButtonText = '← Back to Sports',
  backButtonPath = '/',
  itemIconKey = 'icon',
  itemTitleKey = 'title',
  itemSubtitleKey = 'subtitle',
  itemColorKey = 'color',
  itemLinkKey = 'link',
  itemLinkPrefix = '',
  className = 'sport-selection',
  selectedPlayers = null,
  onRemovePlayer = null,
  onAddPlayer = null,
  allPlayers = null,
  onLockedClick = null,
  equipmentGuide = null,
  showEquipmentGuide = true,
  onShowEquipment = null,
}) {
  const navigate = useNavigate();

  const handleEquipmentDismiss = () => {
    console.log('SportGrid handleEquipmentDismiss called');
    if (equipmentGuide?.onClose) {
      console.log('Calling parent onClose');
      equipmentGuide.onClose();
    }
  };

  const handleShowEquipment = () => {
    if (onShowEquipment) {
      onShowEquipment();
    }
  };

  return (
    <div className={className}>
      {showBackButton && (
        <button
          className='back-button'
          onClick={() => navigate(backButtonPath)}
        >
          {backButtonText}
        </button>
      )}

      <FloatingPlayerIndicator
        selectedPlayers={selectedPlayers}
        onRemovePlayer={onRemovePlayer}
        onAddPlayer={onAddPlayer}
        allPlayers={allPlayers}
      />

      <h1>{title}</h1>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '20px',
        }}
      >
        <p className='subtitle' style={{ margin: 0 }}>
          {subtitle}
        </p>
        {equipmentGuide && !showEquipmentGuide && (
          <button
            onClick={onShowEquipment}
            style={{
              background: 'none',
              border: 'none',
              color: '#666',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '4px',
              transition: 'color 0.2s ease',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#999')}
            onMouseLeave={(e) => (e.target.style.color = '#666')}
          >
            <HelpCircle size={16} />
          </button>
        )}
      </div>

      {equipmentGuide && showEquipmentGuide && (
        <div style={{ marginBottom: '20px' }}>
          <AchievementToast
            customTitle={equipmentGuide.title}
            customContent={equipmentGuide.content}
            icon={null}
            inline={true}
            dismissible={true}
            autoDismissTime={null}
            onClose={handleEquipmentDismiss}
          />
        </div>
      )}

      <div className='sport-grid'>
        {items.length > 0 ? (
          items.map((item, index) => {
            const isDisabled = item.disabled;

            if (isDisabled) {
              const isPremiumLocked = Boolean(item.premiumLocked);
              return (
                <div
                  key={index}
                  className={`sport-card disabled ${
                    isPremiumLocked ? 'premium-locked' : ''
                  }`}
                  style={{ '--sport-color': item[itemColorKey] }}
                  onClick={() => onLockedClick && onLockedClick(item)}
                >
                  <div className='sport-icon'>{item[itemIconKey]}</div>
                  <h3>{item[itemTitleKey]}</h3>
                  {item[itemSubtitleKey] && (
                    <p className={isPremiumLocked ? 'premium-required' : ''}>
                      {item[itemSubtitleKey]}
                    </p>
                  )}
                </div>
              );
            }

            const fullLink = itemLinkPrefix + item[itemLinkKey];

            return (
              <Link
                key={index}
                to={fullLink}
                className='sport-card'
                style={{ '--sport-color': item[itemColorKey] }}
              >
                <div className='sport-icon'>{item[itemIconKey]}</div>
                <h3>{item[itemTitleKey]}</h3>
                {item[itemSubtitleKey] && <p>{item[itemSubtitleKey]}</p>}
              </Link>
            );
          })
        ) : (
          <div className='no-workouts'>
            <p>No items available yet.</p>
            <p>Check back soon!</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SportGrid;
